import firebase from 'firebase/compat/app'
import 'firebase/compat/auth'
import 'firebase/compat/firestore'

const firebaseApp = firebase.initializeApp({

apiKey: "AIzaSyDFqRPY4-X_Zf30yrrfCyDa3mGECpv46RY",
  authDomain: "clone-e64fc.firebaseapp.com",
  projectId: "clone-e64fc",
  storageBucket: "clone-e64fc.appspot.com",
  messagingSenderId: "755269471344",
  appId: "1:755269471344:web:4bd205989ac609365a38b5",
  measurementId: "G-YYJ19DGL6W"

});
  

const auth = firebase.auth();

export  { auth};




